var map;
var geocoder;
var markers;
var uAjax = "/index.cfm/shop/ajax/geolocateshops";

$(function()
{
	if(typeof apiKey !== "undefined"){
		var url = 'https://maps.googleapis.com/maps/api/js?key='+apiKey+'&callback=initializeMap';
		$.getScript(url);
	}
	else{
		// Init Google Maps
		if(typeof google !== 'undefined')
		{
			google.maps.event.addDomListener(window, 'load', initializeMap);
		}
	}

	$('#btnSearch').on('click',function()
	{
		var sLocation          = $('.edtLocation').val();
		var sLookupCountry = sCountryCode;
		var sLookupCountryCode = sCountryCode;
		if(typeof $('.inputSearchCountry').val() !== "undefined")
		{
			sLookupCountry = $('.inputSearchCountry').find('option:selected').html();
			sLookupCountryCode =  $('.inputSearchCountry').val();
		}

		if(sLocation != '')
		{
			geoLookup(sLocation,sLookupCountry,handleGeolocateshops,sLookupCountryCode);
		}
	});

	$(".shopList > .row").mouseenter(function(e){
		$(this).addClass('hover');
	});

	$(".shopList > .row").mouseleave(function(e){
		$(this).removeClass('hover');
	});

	// A-Z index accordion (ECOMMA-4023). The groups render <details open> so the desktop grid and a
	// no-JS client both read in full; below 767px the design asks for an accordion, so we close them
	// here and drive the state ourselves. Only one group is ever open: opening one closes the rest,
	// whether it was opened from a letter chip or from the letter row itself.
	var oShopIndex = $('.shopIndexGroups');
	if(oShopIndex.length)
	{
		var isShopIndexMobile = function()
		{
			return window.matchMedia('(max-width: 767px)').matches;
		};

		// <details> cannot transition on its own, so we slide the list ourselves. The open attribute
		// has to stay on for the whole closing slide, otherwise <details> would hide the list at once
		// and there would be nothing left to animate. That makes the attribute a poor record of what
		// the user asked for mid-animation, so intent is tracked separately and the attribute follows.
		var toggleShopIndexGroup = function(oGroup, bOpen)
		{
			if((oGroup.data('shopIndexOpen') ? true : false) === bOpen)
			{
				return;
			}

			oGroup.data('shopIndexOpen', bOpen);
			var oList = oGroup.children('ul');

			if(bOpen)
			{
				// stop first: a slide that is still closing would otherwise run its callback after
				// this and strip the attribute straight back off
				oList.stop(true,true);
				oGroup.attr('open','open');
				oList.hide().slideDown(200);
			}
			else
			{
				oList.stop(true,true).slideUp(200,function()
				{
					if(oGroup.data('shopIndexOpen'))
					{
						return; // reopened while it was sliding shut
					}

					oGroup.removeAttr('open');
					// drop the inline display so a closed group is hidden by <details> itself, which
					// keeps the desktop grid correct if the viewport is widened afterwards
					oList.css('display','');
				});
			}
		};

		// The letter chips are plain anchors, so the browser parked the target group against the top
		// of the viewport on every click. On desktop the index is a four column grid where most
		// groups are already on screen, so a click threw the page around for nothing (ECOMMA-4034).
		// Scroll by the smallest amount that brings the group fully into view instead, and not at
		// all when it already is.
		var iShopIndexScrollMargin = 16;

		var scrollShopIndexGroupIntoView = function(oGroup)
		{
			var oNode = oGroup[0];
			if(!oNode || typeof oNode.getBoundingClientRect !== 'function')
			{
				return;
			}

			// the header only carries fixedActive while it is actually stuck, so this is 0 the rest
			// of the time and the group lines up with the viewport itself
			var oFixedHeader = $('header.fixedActive').not('.fixedHeaderClone');
			var iTopLimit    = (oFixedHeader.length ? oFixedHeader.outerHeight() : 0) + iShopIndexScrollMargin;
			var iViewHeight  = window.innerHeight || document.documentElement.clientHeight;
			var oRect        = oNode.getBoundingClientRect();
			var iDelta       = 0;

			if(oRect.top < iTopLimit)
			{
				iDelta = oRect.top - iTopLimit;
			}
			else if(oRect.bottom > iViewHeight - iShopIndexScrollMargin)
			{
				// a group taller than the window can never fit, so stop once its heading reaches the
				// top rather than scrolling past it chasing the bottom edge
				iDelta = Math.min(oRect.bottom - iViewHeight + iShopIndexScrollMargin, oRect.top - iTopLimit);
			}

			// already in view: leave the page where the reader left it
			if(Math.abs(iDelta) < 2)
			{
				return;
			}

			$('body,html').stop(true).animate({ scrollTop: $(window).scrollTop() + iDelta }, 300);
		};

		// only ever one group open: whatever opens one closes the rest
		var openShopIndexGroup = function(oGroup)
		{
			oShopIndex.find('.shopIndexGroup').not(oGroup).each(function()
			{
				toggleShopIndexGroup($(this), false);
			});
			toggleShopIndexGroup(oGroup, true);
		};

		// seed the intent flag from the state we start in: closed on mobile, open everywhere else
		var bIndexStartsOpen = !isShopIndexMobile();
		oShopIndex.find('.shopIndexGroup').each(function()
		{
			var oGroup = $(this);
			if(!bIndexStartsOpen)
			{
				oGroup.removeAttr('open');
			}
			oGroup.data('shopIndexOpen', bIndexStartsOpen);
		});

		oShopIndex.on('click','.shopIndexGroup > summary',function(e)
		{
			// always suppress the native toggle: on desktop every group stays open, and on mobile the
			// animation above drives the state instead
			e.preventDefault();

			if(!isShopIndexMobile())
			{
				return;
			}

			var oGroup = $(this).parent();

			if(oGroup.data('shopIndexOpen'))
			{
				toggleShopIndexGroup(oGroup, false);
			}
			else
			{
				openShopIndexGroup(oGroup);
			}
		});

		$('.shopIndexLetters a').on('click',function(e)
		{
			var oGroup = oShopIndex.find(this.getAttribute('href'));
			if(!oGroup.length)
			{
				return;
			}

			// take over from the native anchor jump, which always parks the group at the very top
			e.preventDefault();

			if(!isShopIndexMobile())
			{
				scrollShopIndexGroupIntoView(oGroup);
				return;
			}

			openShopIndexGroup(oGroup);

			// the group grows while its list slides open, and closing the previous one moves
			// everything below it, so measure once both animations have finished
			setTimeout(function()
			{
				scrollShopIndexGroupIntoView(oGroup);
			}, 220);
		});
	}

	$(".edtLocation").keyup(function (e)
	{
	    if (e.keyCode == 13)
		{
			var sLocation          = $('.edtLocation').val();
			var sLookupCountry = sCountryCode;
			var sLookupCountryCode = sCountryCode;
			if(typeof $('.inputSearchCountry').val() !== "undefined")
			{
				sLookupCountry = $('.inputSearchCountry').find('option:selected').html();
				sLookupCountryCode =  $('.inputSearchCountry').val();
			}

			if(sLocation != '')
			{
				geoLookup(sLocation,sLookupCountry,handleGeolocateshops,sLookupCountryCode);
			}
		}
	});

	$(el('searchShop')).on('click','.searchShop .doSearch',function(){
		var sLocation          = $(this).prev().val();
		var sLookupCountry     = sCountryCode;
		var sLookupCountryCode = sCountryCode;

		if(typeof $('.inputSearchCountry').val() !== "undefined")
		{
			sLookupCountry = $('.inputSearchCountry').find('option:selected').html();
			sLookupCountryCode = $('.inputSearchCountry').find('option:selected').val();
		}
		if(sLocation !== '')
		{
			geoLookup(sLocation,sLookupCountry,searchShop,sLookupCountryCode);
		}
	});
	$(el('searchShop')).on('keyup','.searchShop .search',function(e){
		if(e.which === 13)
		{
			var sLocation          = $(this).val();
			var sLookupCountry     = sCountryCode;
			var sLookupCountryCode = sCountryCode;

			if(typeof $('.inputSearchCountry').val() !== "undefined")
			{
				sLookupCountry = $('.inputSearchCountry').find('option:selected').html();
				sLookupCountryCode = $('.inputSearchCountry').find('option:selected').val();
			}
			if(sLocation !== '')
			{
				geoLookup(sLocation,sLookupCountry,searchShop,sLookupCountryCode);
			}
		}
	});

	$(el('mainContainer')).on('change','.inputSearchCountry',function(e){
		fnCountryChanged(e);
	});

	// the locationPromptShopList setting is the gate. This used to ALSO require isTouchDevice(), so a
	// desktop browser was never asked for location and the nearby list never sorted by distance
	// (ECOMMA-4007). Denying the prompt is still fine: the list just keeps its default order.
	if (typeof bLocationPromptShopList !== 'undefined' && bLocationPromptShopList == 1)
	{
		getLocation();
	}

	// app-level shop list: open-status chips + the "open now" filter (CSS keys on data-filter-open)
	initShopOpenStatus();
	$(el('mainContainer')).on('change', '#chkOpenNow', function(){
		// trigger('scroll') resyncs the scroll fade to the filtered list height
		$('.shopRows').attr('data-filter-open', this.checked ? '1' : '0').trigger('scroll');
	});
});

// --- app-level shop list (design rebuild) ---
// Open-status is computed CLIENT-side from each row's data-hours string so cached pages stay correct;
// the labels travel on the .shopRows data-tr-* attributes (no copy in JS). Re-run after every ajax
// replace of .shopOverview.
function initShopOpenStatus()
{
	var $wrap = $('.shopRows');
	if (!$wrap.length) { return; }

	var sClosedText = $wrap.attr('data-closed-text') || '';
	var oLabels = {
		open:   $wrap.attr('data-tr-open') || '',
		soon:   $wrap.attr('data-tr-closing-soon') || '',
		closed: $wrap.attr('data-tr-closed') || ''
	};

	$wrap.find('.shopRow').each(function(){
		var $row    = $(this);
		var sStatus = computeShopOpenStatus($row.attr('data-hours') || '', sClosedText);
		$row.attr('data-status', sStatus);
		$row.find('.shopRowStatus')
			.removeClass('shopRowStatus--open shopRowStatus--soon shopRowStatus--closed')
			.addClass('shopRowStatus--' + sStatus)
			.find('.shopRowStatus__label').text(oLabels[sStatus]);
	});

	$wrap.attr('data-filter-open', $('#chkOpenNow').is(':checked') ? '1' : '0');

	initShopListScrollFade($wrap);
}

// scroll fade-out on the nearby list (design): the .shopOverview wrapper shows a bottom fade only
// while the row list overflows and isn't scrolled to its end. Runs per (re)rendered .shopRows —
// the wrapper persists across ajax replaces, the list element does not, so bindings never stack.
function initShopListScrollFade($wrap)
{
	var oList    = $wrap[0];
	var $overview = $wrap.closest('.shopOverview');
	if (!$overview.length) { return; }

	function syncFade()
	{
		$overview
			.toggleClass('hasScroll', oList.scrollHeight > oList.clientHeight + 1)
			.toggleClass('atEnd', oList.scrollTop + oList.clientHeight >= oList.scrollHeight - 8);
	}

	$wrap.on('scroll', syncFade);
	syncFade();
}

// parses "9u00 - 18u00" / "09:00-12:00, 13:00-18:00" / "9h00 - 18h00" into [open,close] pairs;
// within an hour of closing = 'soon'; unparsable strings read as closed
function computeShopOpenStatus(sHours, sClosedText)
{
	if (!sHours || (sClosedText && sHours.indexOf(sClosedText) > -1)) { return 'closed'; }

	var aTimes = sHours.match(/(\d{1,2})\s*[uUhH:.](\d{2})/g);
	if (!aTimes || aTimes.length < 2) { return 'closed'; }

	var oNow = new Date();
	var iNow = oNow.getHours() * 60 + oNow.getMinutes();

	for (var i = 0; i + 1 < aTimes.length; i += 2)
	{
		var aOpen  = aTimes[i].match(/(\d{1,2})\s*[uUhH:.](\d{2})/);
		var aClose = aTimes[i + 1].match(/(\d{1,2})\s*[uUhH:.](\d{2})/);
		var iOpen  = parseInt(aOpen[1], 10) * 60 + parseInt(aOpen[2], 10);
		var iClose = parseInt(aClose[1], 10) * 60 + parseInt(aClose[2], 10);

		if (iNow >= iOpen && iNow < iClose)
		{
			return (iClose - iNow <= 60) ? 'soon' : 'open';
		}
	}
	return 'closed';
}

var fnCountryChanged = function(oEvent){

	if($(oEvent.currentTarget).val() != ""){
		var sCountry = $(oEvent.currentTarget).find('option:selected').html();
		geocoder.geocode( {'address' : sCountry}, function(results, status) {
		    if (status == google.maps.GeocoderStatus.OK) {
		        map.panTo(results[0].geometry.location);
				map.fitBounds(results[0].geometry.viewport);
				map.panToBounds(results[0].geometry.viewport);
				// zoom 1 lvl deeper, GMaps is too conservative
				map.setZoom(map.getZoom()+1);
		    }
		});
		$('.locationInputBox').show();
	}
	else{
		$('.locationInputBox').hide();
	}
}

function getLocation() {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(showPosition);
	}
}

function handleGeolocateshops(oLookup)
{
	if(typeof toList != 'undefined' && toList == 1)
	{
		var sParams = '?latitude=' + oLookup.results[0].geometry.location.lat()
		+ '&longitude=' + oLookup.results[0].geometry.location.lng()
		+ '&location=' + oLookup.location
		+ '&countryCode=' + oLookup.countryCode;
		window.location = '/' + sCurrentLanguageCode + '/shop/list/' + sParams;
	}
	else
	{
		$(document).trigger( "findLocation");
		map.panTo(oLookup.results[0].geometry.location);
		map.fitBounds(oLookup.results[0].geometry.viewport);

		var sParams = '&latitude=' + oLookup.results[0].geometry.location.lat()
		+ '&longitude=' + oLookup.results[0].geometry.location.lng() + "&countryCode=" + oLookup.countryCode;


		var oCall = callAjax("geolocateshops", sParams, "post");

		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				$('.shopOverview').html(oData.html);
				initShopOpenStatus();
			}
			else
			{
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}

			// Hide loader
			$('.ajaxLoader').fadeOut(200);
		});
	}
}
function initializeMap() {

	map = new google.maps.Map(document.getElementById('googleMap'),
		mapOptions);
	geocoder = new google.maps.Geocoder();
	markers = googleMapMarkers();
	$('.inputSearchCountry').trigger('change');
}

function showPosition(position) {
	var sParams = '&latitude=' + position.coords.latitude
	+ '&longitude=' + position.coords.longitude;

	var oCall = callAjax("geolocateshops", sParams, "post");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			$('.shopOverview').html(oData.html);
			initShopOpenStatus();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}

		// Hide loader
		$('.ajaxLoader').fadeOut(200);
	});
}

if(typeof callbackClosestShop === "undefined"){
	var callbackClosestShop = function(sShopId,sLocation)
	{
		var sParams = '&id=' + sShopId;
		var oCall = callAjax("detail", sParams, "post", "/index.cfm/shop/ajax/detail");

		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				if(!geocoder)
				{
					geocoder = new google.maps.Geocoder();
				}
				geocoder.geocode( { 'address': sLocation+",be"}, function(results, status)
				{
					map.setZoom(12);
					map.setCenter(results[0].geometry.location);
				});

				$('.shopDetail').html(oData.html);
			}
			else if(oData.errorType === 'loggedOut')
			{
				location.reload();
			}
			else
			{
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
}